var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-product-btn"},[_c('DeleteIconSVG')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }